<template>
  <div class="center-form auth-form">
    <form class="app-form">
      <template v-if="!!authError.license">
        <a-result
            status="error"
            :title="authError.license"
        />
      </template>
      <template v-else>
        <div class="gradient-line"></div>
        <div class="app-form-head">
          <div class="shield-bg">
            <icon-shield/>
          </div>
          <div class="our-name" v-if="isCrypto">Trade-Desk.o4biz.ru</div>
          <h1>Вход в систему</h1>
          <div class="description">Введите логин и пароль, чтобы получить доступ к рабочему столу. Если доступа нет —
            обратитесь к администратору.
          </div>
        </div>

        <div class="app-form-body">
          <label>Логин</label>

          <a-input
              v-model:value="email"
              placeholder="Логин (E-mail):"
              size="large"
              :class="{error: authError && authError.userLogin && authError.userLogin[0]}"
          >
            <template #prefix>
              <icon-user/>
            </template>
            <template v-if="authError && authError.userLogin && authError.userLogin[0]" #suffix>
              <a-tooltip class="error" :title="authError.userLogin[0]">
                <QuestionCircleOutlined/>
              </a-tooltip>
            </template>
          </a-input>

          <label>Пароль</label>

          <a-input-password
              v-model:value="pass"
              placeholder="Пароль:"
              size="large"
              :class="{error: authError && authError.userPass && authError.userPass[0]}"
          >
            <template #prefix>
              <icon-pass/>
            </template>
          </a-input-password>

          <a-checkbox v-model:checked="rememberMe">Запомнить меня</a-checkbox>
        </div>

        <div class="app-form-footer displayFlexSBRW vAlignCenter">
          <a-button
              type="primary"
              @click="handleLogin"
              size="large"
          >
            <icon-login/>
            Войти
          </a-button>
        </div>
      </template>
    </form>

    <div class="copyrights">
      <copyright/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconShield from "@/components/icons/Shield";
import IconUser from "@/components/icons/User";
import IconPass from "@/components/icons/Pass";
import IconLogin from "@/components/icons/Login";
import Copyright from "@/components/Copyright";

export default {
  name: "UserAuth",
  components: { Copyright, IconLogin, IconPass, IconUser, IconShield },
  data() {
    return {
      email: "",
      pass: "",
      rememberMe: true,
    };
  },

  computed: {
    ...mapGetters([ "auth", "authError" ]),
    isCrypto() {
      return process.env.pack == 'crypto'
    }
  },

  methods: {
    ...mapActions([ "login", "startLoading", "stopLoading" ]),

    handleLogin() {
      this.startLoading();
      this.login({
        userLogin: this.email,
        userPass: this.pass,
        rememberMe: this.rememberMe,
        callback: (e) => {
          if (e.status) {
            this.$router.push('/');
          }
          this.stopLoading();
        }
      });
    }
  }
};
</script>

<style lang="less">
.auth-form {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  height: auto !important;

  * {
    font-family: Inter, Arial, sans-serif;
  }

  .app-form {
    border-radius: 12px;

    h1 {
      margin-top: 8px;
    }

    .description {
      margin-top: 12px;
      font-size: 14px;
      line-height: 24px;
      color: rgb(101, 114, 133);
    }
  }
}

.center-form {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .ant-input-suffix {
    .error {
      color: red;
    }
  }

  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    height: 44px;
    margin-bottom: 0;
  }

  .ant-btn {
    margin-top: 10px;
    width: 100%;
  }
}

.copyrights {
  width: 100%;
  padding-top: 48px;
  padding-bottom: 32px;
  font-size: 12px;
  color: rgb(101, 114, 133);

  a {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    margin-left: 20px;
  }
}
</style>
